<template>
  <div class="flex-1">
    <template v-if="isLoadingDetails">
      <stormy-spinner :show="isLoadingDetails" />
    </template>

    <div
      v-else
    >
      <div class="py-6 px-8 text-lg font-medium border-b">
        {{ contact.r_full_name_without_salutation }}
      </div>
      <div class="py-6 px-4">
        <div class="grid grid-cols-2">
          <div>
            <stormy-dl-item
              label="Anrede"
              :value="contact.salutation?.name"
            />
          </div>
          <div>
            <stormy-dl-item
              label="Titel"
              :value="contact.title"
            />
          </div>
        </div>
        <div class="grid grid-cols-2">
          <div>
            <stormy-dl-item
              label="Vorname"
              :value="contact.first_name"
            />
          </div>
          <div>
            <stormy-dl-item
              label="Name"
              :value="contact.last_name"
            />
          </div>
        </div>

        <stormy-dl-item
          label="Telefon"
          :value="contact.phone"
        />
        <stormy-dl-item
          label="E-Mail"
          :value="contact.email"
        />
        <div>
          <stormy-dl-item
            label="Firma"
            :value="contact.company"
          />
          <stormy-dl-item
            label="Rechnungsanschrift"
            :value="contact.id"
          >
            <div v-html="nl2br(contact.address)" />
          </stormy-dl-item>
        </div>
        <div>
          <stormy-dl-item
            label="Notiz"
            :value="contact.note"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'

import { useContactStore } from '@/pinia/ContactStore.js'
import { useTemplateFilter } from '@/composables/useTemplateFilter.js'
const { nl2br } = useTemplateFilter()

const concatStore = useContactStore()
const { contact, isLoadingDetails } = storeToRefs(concatStore)

</script>
